import React, { useState, useRef, useEffect } from "react";
import SelectArrow from "../svg/select-arrow";

interface SelectProps {
    label: string;
    placeholder?: string;
    options: string[];
    value: string;
    onChange: (value: string) => void;
    errorMessage?: string;
}

const Select: React.FC<SelectProps> = ({ label, placeholder, options, value, onChange, errorMessage }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleSelect = (option: string) => {
        onChange(option);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="relative w-full" ref={selectRef}>
            <div className={`absolute z-10 -top-2 left-[14px] text-[12px] max-[576px]:text-[10px] uppercase bg-white px-[4px] py-[2px] transition-all ${value ? "text-[#3b49c0]" : "text-violet-300"}`}>
                {label}
            </div>

            <div
                className="relative flex items-center border-[1.5px] border-violet-50 rounded-[12px] p-4 w-full cursor-pointer"
                onClick={toggleDropdown}
            >
                <span className="flex-1 text-violet-200 text-[18px] max-[576px]:text-[14px]">
                    {value || placeholder || "Select an option"}
                </span>
                <span className="absolute right-[14px] top-1/2 -translate-y-1/2">
                    <SelectArrow />
                </span>
            </div>

            {isOpen && (
                <ul className="absolute left-0 pl-[14px] pr-[14px] w-full bg-white rounded-[12px] shadow-[0_4px_16px_0_#0000001a] shadow-md max-h-48 overflow-y-auto z-20">
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className="px-[9px] py-[9px] uppercase cursor-pointer text-black text-[18px] font-medium border-b-2 border-dashed last:border-b-0"
                            onClick={() => handleSelect(option)}
                        >
                            {option}
                        </li>
                    ))}
                </ul>
            )}

            {errorMessage && <div className="text-red-500 text-sm mt-2">{errorMessage}</div>}
        </div>
    );
};

export default Select;
